import { GET_LISTE_DEVIS, ADD_DEVIS, UPDATE_DEVIS, DELETE_DEVIS } from '../actions/action-types';

const initialState = {
    liste: [],      // devis chargés depuis le serveur
    loaded: false,
};

export default function devisReducer(state = initialState, action) {
    switch (action.type) {

        case GET_LISTE_DEVIS:
            return { ...state, liste: action.payload || [], loaded: true };

        case ADD_DEVIS:
            return { ...state, liste: [action.payload, ...state.liste] };

        case UPDATE_DEVIS:
            return {
                ...state,
                liste: state.liste.map(d =>
                    d.id === action.payload.id ? { ...d, ...action.payload } : d
                ),
            };

        case DELETE_DEVIS:
            return {
                ...state,
                liste: state.liste.filter(d => d.id !== action.payload),
            };

        default:
            return state;
    }
}
